module.exports = __webpack_public_path__ + "static/media/rocket_launch.212ba375.svg";